import { FreelancerPayment } from "../bank";
import { IConverter, TSnapshot } from "./generics";

export const freelancerPaymentConverter: IConverter<FreelancerPayment> =
  {
    toFirestore(payment: FreelancerPayment) {
      const data = {
        id: payment.id,
        userId: payment.userId,
        amount: payment.amount,
        status: payment.status,
        increaseStatus: payment.increaseStatus,
        paymentDate: payment.paymentDate,
        createdAt: payment.createdAt,
        submittedByAdminUserId: payment.submittedByAdminUserId,
        clientId: payment.clientId,
        updatedAt: payment.updatedAt,
        direction: payment.direction,
        increaseExternalAccountId: payment.increaseExternalAccountId,
        externalPaymentSource: payment.externalPaymentSource,
        expectedSettlementDate: payment.expectedSettlementDate,
        isExternalPayment: payment.isExternalPayment,
        approvedByAdmin: payment.approvedByAdmin,
        approvedByAdminAt: payment.approvedByAdminAt,
        memo: payment.memo,
        projectId: payment.projectId,
        projectAssignmentId: payment.projectAssignmentId,
        csaId: payment.csaId,
      };
      return data;
    },
    fromFirestore(snapshot: TSnapshot): FreelancerPayment {
      const data = snapshot.data();
      return {
        id: snapshot.id,
        userId: data?.userId,
        amount: data?.amount,
        status: data?.status,
        increaseStatus: data?.increaseStatus,
        paymentDate: data?.paymentDate,
        createdAt: data?.createdAt,
        submittedByAdminUserId: data?.submittedByAdminUserId,
        clientId: data?.clientId,
        updatedAt: data?.updatedAt,
        direction: data?.direction,
        increaseExternalAccountId: data?.increaseExternalAccountId,
        externalPaymentSource: data?.externalPaymentSource,
        expectedSettlementDate: data?.expectedSettlementDate,
        isExternalPayment: data?.isExternalPayment,
        approvedByAdmin: data?.approvedByAdmin,
        approvedByAdminAt: data?.approvedByAdminAt,
        memo: data?.memo,
        projectId: data?.projectId,
        projectAssignmentId: data?.projectAssignmentId,
        csaId: data?.csaId,
      };
    },
  };
